import {Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, Inject} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import {MatAutocomplete} from "@angular/material/autocomplete";
import {User} from "../../../auth/user.model";
import {UtilsService} from "../../../shared/utils.service";
import {ChangeImageComponent} from "../../../shared/change-image/change-image.component";
import {LogosCompany} from "../../../shared/logos-company.model";

@Component({
    selector: 'app-add-logo',
    templateUrl: './add-logo.component.html',
    styleUrls: ['./add-logo.component.scss'],
    standalone: false
})
export class AddLogoComponent implements OnInit {
  logo: LogosCompany;
  addLogoForm: FormGroup;
  invalidImages = false;
  imagesList: Array<string>;
  fileList: Array<any>;
  userID: any;
  user: User;
  isLoading: boolean;

  constructor(public dialogRef: MatDialogRef<AddLogoComponent>,
              private dataService: DataService,
              public utils: UtilsService,
              private authService: AuthService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.isLoading = false;
    this.user = this.authService.getUserData();
    this.userID = this.user.id;
    this.imagesList = new Array<string>();
    this.fileList = new Array();
  }

  ngOnInit(): void {
    this.addLogoForm = new FormGroup({
      title: new FormControl( null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
    });
  }

  closeDialog() {
      if (this.addLogoForm.dirty) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Warning',
            type: 'Warn',
            message: 'You will miss your information once you close',
            buttonText: 'cancel',
            numberOfButtons: 2,
            seconButtonText: 'Ok'
          }
        });
        dialogRef.afterClosed().subscribe((status) => {
          if (status === 'Ok') {
            this.dialog.closeAll();
          }
        });
      }
      else{
        this.dialog.closeAll();
      }
  }

  addImage() {
    this.dialog.open(ChangeImageComponent, {
      width: '610px',
      data: { dialogParent: this, title: 'Add New Image', resizeImage: true }
    }).afterClosed().subscribe(result => {
      if (result !== undefined && result.croppedImage64 !== undefined) {
        const imgSrc = result.croppedImage64;
        this.imagesList.push(imgSrc);
        this.fileList.push(result.ImageData);
        this.invalidImages = false;
      }
    });
  }

  deleteImage(index: number) {
    if (index > -1) {
      this.imagesList.splice(index, 1);
      this.fileList.splice(index, 1);
      if (this.imagesList.length === 0) {
        this.invalidImages = true;
      } else {
        this.invalidImages = false;
      }
    }
  }

  onSubmit() {
    if (this.addLogoForm.valid && this.fileList.length > 0) {
      this.utils.showProgressDialog();

      let imageData = this.imagesList[0];
      if (imageData.startsWith('data:image')) {
      imageData = imageData.substring(imageData.indexOf(',') + 1);
    }
      const payload = {
        title: this.addLogoForm.get('title')?.value,
        image: imageData
      };
      this.dataService.post('logos/Create', payload, true).then((data: any) => {
        if (data.statusCode === 200) {
              payload['id'] = data.data.id;
              this.dialogRef.close(payload);
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Logo added successfully',
                  buttonText: 'Ok'
                }
              });
        } else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, Please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });
      this.utils.closeProgressDialog();
    } else {
      if (this.imagesList.length === 0) {
        this.invalidImages = true;
      }
      this.addLogoForm.markAllAsTouched();
    }
  }
}
